export enum TrackingItemStatus {
    UNKNOWN = 'UNKNOWN',
    PENDING = 'PENDING',
    RUNNING = 'RUNNING',
    COMPLETED = 'COMPLETED',
}
